import React, { forwardRef } from "react";
import Barcode from "react-barcode";

interface PrintableRackLabelsProps {
  barcodes: string[];
}

export const PrintableRackLabels = forwardRef<
  HTMLDivElement,
  PrintableRackLabelsProps
>(({ barcodes }, ref) => {
  return (
    <div ref={ref} style={styles.page}>
      {barcodes.map((code, idx) => {
        const shouldAddTopMargin = idx % 10 === 0 || idx % 10 === 1;
        const isNewPageRow = idx % 10 === 0 && idx !== 0;

        return (
          <div
            key={idx}
            style={{
              ...styles.labelBox,
              marginTop: shouldAddTopMargin ? "10mm" : undefined,
              breakBefore: isNewPageRow ? "page" : undefined,
            }}
          >
            <Barcode
              value={code}
              height={110}
              fontSize={18}
              width={3}
              displayValue
            />
          </div>
        );
      })}
    </div>
  );
});

const styles: { [key: string]: React.CSSProperties } = {
  page: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    paddingBottom: "10mm",
    paddingLeft: "6.5mm",
    width: "210mm",
    height: "297mm",
    boxSizing: "border-box",
    borderRadius: "16px",
  },
  labelBox: {
    border: "1px solid #ccc",
    height: "55mm",
    width: "95mm",
    padding: "12px",
    borderRadius: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    pageBreakInside: "avoid",
  },
};
